import { render, staticRenderFns } from "./OrderColumn.vue?vue&type=template&id=30ab9e85&scoped=true"
import script from "./OrderColumn.vue?vue&type=script&lang=js"
export * from "./OrderColumn.vue?vue&type=script&lang=js"
import style0 from "./OrderColumn.vue?vue&type=style&index=0&id=30ab9e85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab9e85",
  null
  
)

export default component.exports